export default __webpack_public_path__ + "static/thumb-landscape-1909f6f93a457de4859febaa7ad62a5b.jpg";